import React, { createContext, useState } from 'react';
import { useMedia } from '../hooks/useMedia';

interface Bubble {
  open: boolean;
  active: string;
  defaultServiceSelected?: string;
}

const DEFAULT_BUBBLE = {
  open: false,
  active: 'Front',
  defaultServiceSelected: undefined,
};

interface LayoutContextValue {
  isMobile: boolean;
  isIOS: boolean;
  isIE: boolean;
  isEdge: boolean;
  bubble: Bubble;
  setBubble: React.Dispatch<React.SetStateAction<Bubble>>;
  isSubnav: boolean;
  setIsSubnav: React.Dispatch<React.SetStateAction<boolean>>;
  isNavigationOpen: boolean;
  setIsNavigationOpen: React.Dispatch<React.SetStateAction<boolean>>;
  lastScrollPosition: number;
  setLastScrollPosition: React.Dispatch<React.SetStateAction<any>>;
  scrollDisabled: boolean;
  setScrollDisabled: React.Dispatch<React.SetStateAction<any>>;
}

export const LayoutContext = createContext<LayoutContextValue>({
  isMobile: false,
  isIOS: false,
  isEdge: false,
  bubble: DEFAULT_BUBBLE,
  setBubble: () => void 0,
  isSubnav: false,
  setIsSubnav: () => void 0,
  isNavigationOpen: false,
  setIsNavigationOpen: () => void 0,
  lastScrollPosition: 0,
  setLastScrollPosition: () => void 0,
  scrollDisabled: false,
  setScrollDisabled: () => void 0,
  isIE: false,
});

export function LayoutProvider({ children }: { children: React.ReactNode }) {
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const [scrollDisabled, setScrollDisabled] = useState(false);
  const [isSubnav, setIsSubnav] = useState(false);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  const [bubble, setBubble] = useState<Bubble>(DEFAULT_BUBBLE);
  const isMobile = useMedia('sm');
  const isIOS =
    typeof window !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isIE =
    typeof window !== 'undefined' &&
    /Trident\/|MSIE/.test(window.navigator.userAgent);
  const isEdge =
    typeof window !== 'undefined' && navigator.userAgent.indexOf('Edge') !== -1;
  return (
    <LayoutContext.Provider
      value={{
        isMobile,
        isIOS,
        isIE,
        isEdge,
        bubble,
        setBubble,
        isSubnav,
        setIsSubnav,
        isNavigationOpen,
        setIsNavigationOpen,
        scrollDisabled,
        setScrollDisabled,
        lastScrollPosition,
        setLastScrollPosition,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
}
